export const VALID_STATUS = /\/usable$|\/canceled$/;

export const VALID_SIGNAL = /\/update$|\/correctionshort$|\/correction$|\/repeat$|\/isplanned$|\/dpacontacts$/;
